import { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '@/platform/store/types';

import {
  thunkCancelMfa,
  thunkDoLogin,
  thunkDoLoginToken,
  thunkDoLogout,
  thunkGoogleLogin,
  thunkHandleOAuthCallback,
  thunkVerifyMfa,
} from '../../infrastructure/redux/authThunks';

export const useAuth = () => {
  const { isAuthenticated, isLoading } = useAppSelector((state) => state.auth);
  const user = useAppSelector((state) => state.auth.user);
  const token = useAppSelector((state) => state.auth.token);
  const mfaChallenge = useAppSelector((state) => state.auth.mfaChallenge);
  const mfaError = useAppSelector((state) => state.auth.mfaError);

  const dispatch = useAppDispatch();

  const doLogout = () => {
    dispatch(thunkDoLogout());
  };

  const doLogin = (data: { email: string; password: string }) => {
    dispatch(thunkDoLogin({ username: data.email, password: data.password }));
  };

  const doTokenLogin = useCallback(
    (tokenId: string) => {
      dispatch(thunkDoLoginToken(tokenId));
    },
    [dispatch],
  );

  const verifyMfa = (otp_code: string) => {
    dispatch(thunkVerifyMfa(otp_code));
  };

  const cancelMfa = () => {
    dispatch(thunkCancelMfa());
  };

  const googleLogin = useCallback(() => {
    dispatch(thunkGoogleLogin());
  }, [dispatch]);

  const handleOAuthCallback = useCallback(
    (stateParam: string) => dispatch(thunkHandleOAuthCallback(stateParam)),
    [dispatch],
  );

  return {
    isAuthenticated,
    isLoading,
    user,
    token,
    mfaChallenge,
    mfaError,
    doLogout,
    doLogin,
    doTokenLogin,
    verifyMfa,
    cancelMfa,
    googleLogin,
    handleOAuthCallback,
  };
};
